import { createFileRoute, notFound } from '@tanstack/react-router';

import { buildGuards, hasPermission } from '@mint-lib/routing-guards';
import { Categories, Tags } from '@mint-sdk/api-tags';
import { z } from 'zod';

const guard = buildGuards(hasPermission('brandsGeographiesFeature:view'));

const tabValueZodSchema = z.union([z.literal('brands'), z.literal('geo')]);

export type BrandsTabValueType = z.infer<typeof tabValueZodSchema>;

export const Route = createFileRoute('/_secured/company-profile/brands/')({
  async beforeLoad({ context, search }) {
    const guardsContext = await context.getGuardContext();
    if (!guard(guardsContext)) {
      throw notFound();
    }
  },
  validateSearch: z.object({
    search: z.string().optional(),
    tabsValue: z.string().prefault('brands'),
  }),
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/brands');

    const isTreeDataMint2 = await context.isFlagEnabled(
      '@mint/arm',
      'brandsAndGeoToMdmTreeData',
    );

    if (isTreeDataMint2) {
      await context.getInstance('i18n', '@myn/brands_v2');
    }

    const isMint2 = await context.isFlagEnabled(
      '@mint/arm',
      'brandsAndGeoToMdm',
    );

    if (isMint2 && !isTreeDataMint2) {
      const categories = await context.prefetchQuery({
        ...Categories.listQueryOptions({
          params: {},
        }),
        staleTime: 1000 * 60 * 5,
      });
      await context.prefetchQuery({
        ...Tags.listQueryOptions({
          params: {
            categoryType: Object.values(categories)[0]?.name,
          },
        }),
        staleTime: 1000 * 60 * 5,
      });
    }

    const title =
      isMint2 || isTreeDataMint2
        ? i18n.t('Hierarchies | MINT')
        : i18n.t('Brands | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
